import { Component, OnInit } from '@angular/core';
import { MatchService } from '../match.service';
import swal from "sweetalert2";
import { UserService } from '../user.service';

@Component({
  selector: 'app-livetv',
  templateUrl: './livetv.component.html',
  styleUrls: ['./livetv.component.css']
})
export class LivetvComponent implements OnInit {

  match: any;
  isLoading = false;
  constructor(private matchService: MatchService, private userService: UserService) { }

  ngOnInit() {
    this.isLoading = true;
    this.matchService.getAllLiveMatches();
    this.matchService.getUpdateAllLiveMatchListner()
      .subscribe((response) => {
        //console.log(response);
        this.isLoading = false;
        this.match = response.allLiveMatch;
      },
        error => {
          //console.log(error);
          this.isLoading = false;
        });
  }

  setEventId(inc, eventId) {
    var btn = document.getElementById('mbtn' + inc);
    var process = document.getElementById('mprocess' + inc);
    var span = document.getElementById('merror' + inc);
    var mEventId = (<HTMLInputElement>document.getElementById('mEventId' + inc)).value;
    if (mEventId != '') {
      span.style.display = 'none';
      btn.style.display = 'none';
      process.style.display = 'block';

      this.matchService.setEventId(eventId, mEventId).subscribe((response) => {
        //console.log(response);
        this.msgSuccess();
        this.matchService.getAllLiveMatches();
        btn.style.display = 'block';
        process.style.display = 'none';
      },
        error => {
          //console.log(error);
          btn.style.display = 'block';
          process.style.display = 'none';
          this.msgFailure();
        });
    }
    else {
      span.style.display = 'block';
    }
  }

  msgSuccess() {
    swal.fire({
      icon: 'success',
      title: 'Successfully Update!',
      showConfirmButton: false,
      timer: 1500
    })
  }

  msgFailure() {
    swal.fire({
      icon: 'error',
      title: 'Something Went Wrong!',
      showConfirmButton: false,
      timer: 1500
    })
  }

  // setCh(data: any, chNo: any) {
  //   console.log(data, chNo.value);
  //   let body = {
  //     data: data,
  //     chanelid: chNo.value
  //   };

  //   this.matchService.setchno(body).subscribe(
  //     res => {
  //       // console.log(res);
  //       this.msgSuccess();
  //     }
  //   )
  // }
}